import CommonProfessionType from '../CommonProfessionType'

export default class GetProfessionTypeResponse {
  professions: CommonProfessionType[]

  constructor(data: GetProfessionTypeResponse) {
    this.professions = data.professions.map((p) => new CommonProfessionType(p))
  }
}
